module.exports = __webpack_public_path__ + "static/media/student_view_completion_status.a88689b7.png";